module.exports = __webpack_public_path__ + "static/media/mickey3_english_1.50a5a79f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/mickey3_english_1.gif
// module id = 152
// module chunks = 0